/**
 * displays a media component with text on the right side
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import OverlayImage from './OverlayImage';

class SingleMediaBlock extends PureComponent {
    static propTypes = {
        description: PropTypes.string,
        imgSrc: PropTypes.string.isRequired,
        onImageClick: PropTypes.func.isRequired,
    };

    render() {
        return (
            <section className="line r-mrl ">
                <div className="unit r-size1of2">
                    <div className="r-mll r-mbm">
                        <OverlayImage
                            imgSrc={this.props.imgSrc}
                            onImageClick={this.props.onImageClick}
                        />
                    </div>
                </div>
                <div className="unit r-size1of2">
                    <div className="r-mll">
                        <div style={{ cursor: 'default' }}>
                            <p className="t3 man">{this.props.description}</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default SingleMediaBlock;
